import { useStore, useStoreMap } from 'effector-react'
import { supportModel } from '~/widgets/Support'
import { SupportCmsBlockEnum } from '~/shared/config/enums'
import { DrawerComponent } from '~/shared/ui/Drawer'
import { ChevronRightIcon, PhoneIcon } from '~/shared/ui/icons'
import { Card, TitleWrapper, Title } from '../styled'
import { Skeletons } from './Skeletons'

type TabsDrawerProps = {
  isShow: boolean
  onClose: () => void
  onDriverSupportService: () => void
  onParkAddressAndContactsOpen: () => void
  onCarNotStartOpen: () => void
  onRoadAccidentOpen: () => void
  onBreakdownOnRoadOpen: () => void
  onDocumentsOpen: () => void
  onTrafficPoliceFinesDrawerOpen: () => void
}

export function TabsDrawer({
  isShow,
  onClose,
  onDriverSupportService,
  onParkAddressAndContactsOpen,
  onCarNotStartOpen,
  onRoadAccidentOpen,
  onBreakdownOnRoadOpen,
  onDocumentsOpen,
  onTrafficPoliceFinesDrawerOpen,
}: TabsDrawerProps) {
  const isSupportsPending = useStore(supportModel.getSupportsFx.pending)
  const isContactsPending = useStore(supportModel.getContactsFx.pending)

  const supports = useStoreMap(supportModel.$supports, (support) =>
    support?.map((support) => ({
      ...support.getAttributes(),
      id: support.getApiId() as UniqueId,
    })),
  )

  const isAddressAndContactsVisible = (supports || []).some(
    ({ position }) => position === SupportCmsBlockEnum.ADDRESS_AND_CONTACTS,
  )
  const isCarNotStartVisible = (supports || []).some(
    ({ position }) => position === SupportCmsBlockEnum.CAR_NOT_START,
  )
  const isBreakdownOnRoad = (supports || []).some(
    ({ position }) => position === SupportCmsBlockEnum.BREAKDOWN_ON_ROAD,
  )
  const isDocuments = (supports || []).some(
    ({ position }) => position === SupportCmsBlockEnum.DOCUMENTS,
  )
  const isTrafficPoliceFines = (supports || []).some(
    ({ position }) => position === SupportCmsBlockEnum.TRAFFIC_POLICE_FINES,
  )

  return (
    <DrawerComponent isShow={isShow} onCancel={onClose}>
      {(isSupportsPending || isContactsPending) && <Skeletons />}

      {!isSupportsPending && !isContactsPending && (
        <>
          <Card onClick={onDriverSupportService}>
            <TitleWrapper>
              <PhoneIcon />
              <Title style={{ marginLeft: '12px' }}>
                Служба поддержки водителей
              </Title>
            </TitleWrapper>
            <ChevronRightIcon />
          </Card>
          {isAddressAndContactsVisible && (
            <Card onClick={onParkAddressAndContactsOpen}>
              <TitleWrapper>
                <Title style={{ marginLeft: '12px' }}>
                  Адрес и контакты парка
                </Title>
              </TitleWrapper>
              <ChevronRightIcon />
            </Card>
          )}
          {isCarNotStartVisible && (
            <Card onClick={onCarNotStartOpen}>
              <TitleWrapper>
                <Title style={{ marginLeft: '12px' }}>
                  Автомобиль НЕ заводится
                </Title>
              </TitleWrapper>
              <ChevronRightIcon />
            </Card>
          )}
          <Card onClick={onRoadAccidentOpen}>
            <TitleWrapper>
              <Title style={{ marginLeft: '12px' }}>ДТП</Title>
            </TitleWrapper>
            <ChevronRightIcon />
          </Card>
          {isBreakdownOnRoad && (
            <Card onClick={onBreakdownOnRoadOpen}>
              <TitleWrapper>
                <Title style={{ marginLeft: '12px' }}>Поломка в дороге</Title>
              </TitleWrapper>
              <ChevronRightIcon />
            </Card>
          )}
          {isDocuments && (
            <Card onClick={onDocumentsOpen}>
              <TitleWrapper>
                <Title style={{ marginLeft: '12px' }}>Документы</Title>
              </TitleWrapper>
              <ChevronRightIcon />
            </Card>
          )}
          {isTrafficPoliceFines && (
            <Card onClick={onTrafficPoliceFinesDrawerOpen}>
              <TitleWrapper>
                <Title style={{ marginLeft: '12px' }}>Штрафы ГИБДД</Title>
              </TitleWrapper>
              <ChevronRightIcon />
            </Card>
          )}
        </>
      )}
    </DrawerComponent>
  )
}
